import {useCallback} from 'react';
import {useSearchParams, useResolvedPath} from 'react-router-dom';
import ChekinProSettings from 'ChekinProSettings';
import {PATHS} from 'Routes';
import {getIVIntentRemoteSession} from 'hooks/iv/useIVRemoteSync';

export const INTENT_ID = 'intentId';

export const useRemoteStartVerificationLink = () => {
  const pathToDocumentSelection = useResolvedPath(
    `../${PATHS.verification.documentSelection}`,
  );

  const generateRemoteStartVerificationLink = useCallback(() => {
    const intentId = getIVIntentRemoteSession();

    if (ChekinProSettings.isSDK) {
      return location.href.replace(
        PATHS.verification.scanQRCode,
        PATHS.verification.documentSelection,
      );
    }

    return `${import.meta.env.VITE_APP_PUBLIC_URL}${
      pathToDocumentSelection.pathname
    }?${INTENT_ID}=${intentId}`;
  }, [pathToDocumentSelection]);

  return {
    generateRemoteStartVerificationLink,
  };
};

export const useIsRemoteIV = () => {
  const [searchParams] = useSearchParams();

  return {
    intentId: searchParams.get(INTENT_ID),
  };
};
